import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import './style.css';

import { LeftMenuNavigator } from '../../components';

import QuemPodeSer from './quemPodeSer';

const routes = [
  {
    title: 'Quem pode ser',
    link: '',
  },
];

function Associese() {
  let { path } = useRouteMatch();
  return (
    <div id="emprestimosMain">
      <LeftMenuNavigator title="Associe-se" routes={routes} />
      <div id="emprestimosContentContainer">
        <Switch>
          <Route exact path={path}>
            <QuemPodeSer />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Associese;
